export enum RadiusTokensEnum {
  SM = "radius-sm",
  MD = "radius-md",
  PILL = "radius-pill",
}
